import script from "./PartnerOnboardingFormDocumentsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PartnerOnboardingFormDocumentsPage.vue?vue&type=script&lang=ts&setup=true"

import "./PartnerOnboardingFormDocumentsPage.vue?vue&type=style&index=0&id=3c5dd5b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c5dd5b1"]])

export default __exports__